import { Body, H1 } from '@rikstv/shared-components';
import classnames from 'classnames';
import { useBasket } from '~/components/routes/campaign/useBasket';
import { FCC } from '../../../utils/types';
import { FlexBox } from './FlexBox';
import './layout.scss';
import styles from './MainTitle.module.css';

interface Props {
  className?: string;
}

const MainTitle: FCC<Props> = ({ children, className = '' }) => {
  const mainClass = classnames(styles.campaignTitle, className);
  const internetProduct = useBasket((s) => s.selectedProducts).find((p) => p.productType === 'internet');

  return (
    <FlexBox direction="column" alignItems="center" className={styles.wrapper} gap={0.25}>
      <H1 lookLike="title-2" className={mainClass}>
        {children}
      </H1>
      {/* TODO: remove hard coded NextGenTel part */}
      {internetProduct != null && <Body className={styles.subtitle}>Med {internetProduct.displayData.name} fra NextGenTel</Body>}
    </FlexBox>
  );
};

export default MainTitle;
